import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface Iprops {
  item: any;
  current: boolean;
  home: boolean;
}

function TimelineBox({ item, current, home }: Iprops) {
  const navigate = useNavigate();
  // console.log(item, "item");

  return (
    <div>
      <div
        className={`timeline-box ${home && "timeline-box-home"}`}
        id={`timeline-box ${home && "timeline-box-home"}`}
      >
        <div className="info" id="info">
          <Link
            className="name"
            id="name"
            to={home ? `/timeline/${item.rstrNo}` : `/timeline/${item.rstr_no}`}
            draggable={false}
          >
            {home ? item.title : item.brand_name}
            {!home && <span className="middot">&nbsp;&#8231;&nbsp;</span>}
            {!home && item.goods_name}
            <div className="arrow"> </div>
          </Link>
          <div
            className="register-time"
            onClick={() => {
              navigate(
                `${
                  home
                    ? `/timeline/${item.rstrNo}`
                    : `/timeline/${item.rstr_no}`
                }`
              );
            }}
          >
            {home && item.date}
            {!home && item.register_time} {!home && item.completed_time && "~"}{" "}
            {!home && item.completed_time}
          </div>
          <div className="row">
            {current ? (
              <div
                className="state current-state"
                onClick={() => {
                  navigate(
                    `${
                      home
                        ? `/timeline/${item.rstrNo}`
                        : `/timeline/${item.rstr_no}`
                    }`
                  );
                }}
              >
                {home && item.subject}
                {!home && item.state_txt}
              </div>
            ) : (
              <div
                className="state"
                onClick={() => {
                  navigate(
                    `${
                      home
                        ? `/timeline/${item.rstrNo}`
                        : `/timeline/${item.rstr_no}`
                    }`
                  );
                }}
              >
                {item.state_txt}
              </div>
            )}
            {item.state === "PRCM" ? (
              item.flag_review === "N" ? (
                <button
                  type="button"
                  className="review-btn write-review-btn"
                  onClick={() => {
                    navigate(`/myreview/write/${item.rstr_no}`);
                  }}
                >
                  리뷰 작성하기
                </button>
              ) : item.review_no ? (
                <button
                  type="button"
                  className="review-btn view-review-btn"
                  onClick={() => {
                    if (item.review_no) {
                      navigate(`/review/${item.review_no}`);
                    }
                  }}
                >
                  작성한 리뷰 보기
                </button>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          className="img"
          style={{
            backgroundImage: `url(
              ${home ? item.thumbimg2 : item.images[0]?.image_url_m})`,
          }}
          onClick={() => {
            navigate(
              `${
                home ? `/timeline/${item.rstrNo}` : `/timeline/${item.rstr_no}`
              }`
            );
          }}
        >
          {" "}
        </div>
      </div>
    </div>
  );
}

export default TimelineBox;
